<!-- 

<div class="container position-relative"
>

<div class="py-5  row">
<div class="col-md-8 mb-3" style="margin: auto;">
    <div class="rounded shadow-sm p-4 bg-white">
    <h5 class="mb-4">Registration</h5>
    <div id="edit_profile">
    <div>
    <form action="my_account.html">
    <div class="form-group">
    <label for="exampleInputName1">First Name<span class="validate-error" >*</span></label>
    <input type="text" class="form-control" id="firstName" name="firstName"
    [(ngModel)]="registration.firstName"
    (input)="validateTextOnlyLetters($event)" 
    maxlength="30"
    
    >
    <div *ngIf="submited && registration.firstName==''" 
     ><label class="validate-error"> Firstname required</label></div>
    </div>
    <div class="form-group">
    <label for="exampleInputName1">Last Name<span class="validate-error" >*</span></label>
    <input type="text" class="form-control" id="lastName" name="lastName"
    [(ngModel)]="registration.lastName"
    (input)="validateTextOnlyLetters($event)" 
    maxlength="30"
    
    >

    <div *ngIf="submited && registration.lastName==''" 
    ><label class="validate-error"> Last required</label></div>
    </div>
  
    <div class="form-group">
    <label for="exampleInputNumber1">Location<span class="validate-error" >*</span></label>
    <select  class="form-control"   [(ngModel)]="registration.city" (change)="setLocation($event)"  >
        <option    value="0">Select Location</option>
    
        <option *ngFor="let d of lstDeliveryLocation"  
        value={{d.LocationID}}
        >{{d.LocationName}}</option>
        
      </select>

      <div *ngIf="submited && registration.pinCode==''" 
      ><label class="validate-error"> Location  required</label></div>

    </div>
    <div class="form-group">
    <label for="exampleInputEmail1">Address<span class="validate-error" >*</span></label>
    <textarea  rows="4" cols="50" class="form-control"  [(ngModel)]="registration.address"  id="address" name="address"></textarea>
    <div *ngIf="submited && registration.address==''" 
    ><label class="validate-error"> Address required</label></div>

    </div>


    <div class="form-group">
        <label for="exampleInputName1">Email<span class="validate-error" >*</span></label>
        <input type="email" class="form-control" id="email" name="email"
        [(ngModel)]="registration.email"
       
        maxlength="30"
        
        >


        <div *ngIf="submited && registration.email==''" 
        ><label class="validate-error"> Email required</label></div>

        <div *ngIf="submited && registration.email!='' && !validateEmail(registration.email) " 
        ><label class="validate-error"> Invalid  Email</label></div>

        </div>


        <div class="form-group">
            <label for="exampleInputName1">Contact No<span class="validate-error" >*</span></label>
            <input type="text" class="form-control" id="phoneNo" name="phoneNo"
            [(ngModel)]="registration.phoneNo"
           
            maxlength="30"
            
            >

            <div *ngIf="submited && registration.phoneNo==''" 
            ><label class="validate-error"> Contact number required</label></div>

            <div *ngIf="submited && registration.phoneNo!='' && !validateMobile(registration.phoneNo)  " 
            ><label class="validate-error">Invalid Contact number required</label></div>


            </div>



            <div class="form-group">
                <label for="exampleInputName1">Password<span class="validate-error" >*</span></label>
                <input type="password" class="form-control" id="password" name="password"
                [(ngModel)]="registration.password"
               
                maxlength="30"
                
                >
                <div *ngIf="submited && registration.password==''" 
                 ><label class="validate-error"> password required</label></div>
                </div>




                <div class="form-group">
                    <label for="exampleInputName1">Re-Password<span class="validate-error" >*</span></label>
                    <input type="password" class="form-control" id="rePassword" name="rePassword"
                    [(ngModel)]="rePassword"
                   
                    maxlength="30"
                    
                    >
                    <div *ngIf="submited && rePassword==''" 
                     ><label class="validate-error"> Re-Password required</label></div>


                     <div *ngIf="submited && rePassword!='' &&  registration.password!='' && registration.password!=rePassword" 
                     ><label class="validate-error"> Password not matched</label></div>

                    </div>



    <div class="text-center">
    <button type="submit" class="btn btn-primary btn-block" (click)="saveClick()">Save</button>
    </div>
    </form>
    </div>
   
    </div>
    </div>
    </div>
</div>
</div> -->


<!-- <section class="h-100 bg-dark"> -->
    <div class="container-fluid h-100"> 
        <div class="row d-flex justify-content-center align-items-center h-100">
          <!-- <div class="col"> -->
            <div class="card card-registration">
              <div class="row g-0">
                <div class="col-xl-6 d-none d-xl-block">
                  <img  id="imgregistration"
                    alt="Sample photo" class="img-fluid"
                    style="border-top-left-radius: .25rem; border-bottom-left-radius: .25rem;height: 100vh;" />
                </div>
                <div class="col-xl-6">
                  <div class="card-body p-md-3 text-black">
                      <a class="cursor-pointer" (click)="homeClick()"><i class="feather-home mr-2" style="font-size:25px;color:#f00;"></i>Back to Home.</a>
                    <h3 class="mb-3 mt-3 text-uppercase">Registration</h3>
    
                    <div class="row">
                      <div class="col-md-6 form-group">
                          <!-- <div class=""> -->
                              <label for="exampleInputName1">First Name<span class="validate-error" >*</span></label>
                              <input type="text" class="form-control" id="firstName" name="firstName"
                              [(ngModel)]="registration.firstName"
                              (input)="validateTextOnlyLetters($event)" 
                              maxlength="30">
                              <div *ngIf="submited && registration.firstName==''"><label class="validate-error"> Firstname required</label></div>
                              <!-- </div> -->
                          <!-- <input type="text" id="form3Example1m" class="form-control form-control-lg" />
                          <label class="form-label" for="form3Example1m">First name</label> -->
                      </div>
                      <div class="col-md-6 form-group">
                          <!-- <div class="form-group"> -->
                              <label for="exampleInputName1">Last Name<span class="validate-error" >*</span></label>
                              <input type="text" class="form-control" id="lastName" name="lastName"
                              [(ngModel)]="registration.lastName"
                              (input)="validateTextOnlyLetters($event)" 
                              maxlength="30">
                              <div *ngIf="submited && registration.lastName==''"><label class="validate-error"> Last required</label></div>
                              <!-- </div> -->
                        <!-- <div class="form-outline">
                          <input type="text" id="form3Example1n" class="form-control form-control-lg" />
                          <label class="form-label" for="form3Example1n">Last name</label>
                        </div> -->
                      </div>
                    
    
    
                    <!-- <div class="form-outline mb-4">
                      <input type="text" id="form3Example8" class="form-control form-control-lg" />
                      <label class="form-label" for="form3Example8">Address</label>
                    </div> -->
                    <div class="col-md-6 form-group">
                    <!-- <div class="form-group"> -->
                      <label for="exampleInputName1">Email<span class="validate-error" >*</span></label>
                      <input type="email" class="form-control" id="email" name="email"
                      [(ngModel)]="registration.email"
                      maxlength="30">
                      <div *ngIf="submited && registration.email==''" ><label class="validate-error"> Email required</label></div>
                      <div *ngIf="submited && registration.email!='' && !validateEmail(registration.email) " ><label class="validate-error"> Invalid  Email</label></div>
                      <!-- </div> -->
                    </div>

                    <div class="col-md-6 form-group">
                      <!-- <div class="form-group"> -->
                          <label for="exampleInputName1">Contact No<span class="validate-error" >*</span></label>
                          <input type="text" class="form-control" id="phoneNo" name="phoneNo"
                          [(ngModel)]="registration.phoneNo"
                         
                          maxlength="30"
                          
                          >
              
                          <div *ngIf="submited && registration.phoneNo==''" 
                          ><label class="validate-error"> Contact number required</label></div>
              
                          <div *ngIf="submited && registration.phoneNo!='' && !validateMobile(registration.phoneNo)  " 
                          ><label class="validate-error">Invalid Contact number required</label></div>
              
              
                          <!-- </div> -->
                        </div>
                    <div class="col-md-6 form-group">
                      <!-- <div class="form-group"> -->
                          <label for="exampleInputName1">Password<span class="validate-error" >*</span></label>
                          <input type="password" class="form-control" id="password" name="password"
                          [(ngModel)]="registration.password"
                         
                          maxlength="30"
                          
                          >
                          <div *ngIf="submited && registration.password==''" 
                           ><label class="validate-error"> password required</label></div>
                          <!-- </div> -->
                        </div>
          
          
                        <div class="col-md-6 form-group">
                          <!-- <div class="form-group"> -->
                              <label for="exampleInputName1">Re-Password<span class="validate-error" >*</span></label>
                              <input type="password" class="form-control" id="rePassword" name="rePassword"
                              [(ngModel)]="rePassword"
                             
                              maxlength="30"
                              
                              >
                              <div *ngIf="submited && rePassword==''" 
                               ><label class="validate-error"> Re-Password required</label></div>
          
          
                               <div *ngIf="submited && rePassword!='' &&  registration.password!='' && registration.password!=rePassword" 
                               ><label class="validate-error"> Password not matched</label></div>
          
                              <!-- </div> -->
                            </div>
                           
                                <div class="col-md-12 form-group">
                                  <!-- <div class="form-group"> -->
                                      <label for="exampleInputNumber1">Location<span class="validate-error" >*</span></label>
                                      <select  class="form-control"   [(ngModel)]="registration.city" (change)="setLocation($event)"  >
                                          <option    value="0">Select Location</option>
                                      
                                          <option *ngFor="let d of lstDeliveryLocation"  value={{d.ZipCode}} >{{d.LocationName}}</option>
                                          
                                        </select>
                                  
                                        <div *ngIf="submited && registration.pinCode==''" 
                                        ><label class="validate-error"> Location  required</label></div>
                                  
                                      <!-- </div> -->
                                    </div>
                                    <div class="col-md-12 form-group">
                                      <!-- <div class="form-group"> -->
                                      <label for="exampleInputEmail1">Address<span class="validate-error" >*</span></label>
                                      <textarea  rows="4" cols="50" class="form-control"  [(ngModel)]="registration.address"  id="address" name="address"></textarea>
                                      <div *ngIf="submited && registration.address==''" ><label class="validate-error"> Address required</label></div>
                                      </div>
                                    <!-- </div> -->
                                    </div>
                                      <div class="row">
                                          <!-- <div class="col-md-6">
                                              <p class="text-left cursor-pointer mt-1"  (click)="homeClick()" style="font-size:18px;color:#000;">Back to home.</p>
                                          </div> -->
                                          <div class="col-md-12">
                                              <p class="text-right cursor-pointer mt-1"  (click)="loginClick()" style="font-size:18px;color:#000;">Back to login.</p>
                                          </div>
                                      </div>     
                    <div class="d-flex justify-content-center">
                      <button type="submit" class="btn btn-primary btn-lg ms-2" (click)="saveClick()" style="width:50% !important;">Save</button>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          <!-- </div> -->
        </div>
      </div>
    <!-- </section> -->
  
  
  
    